import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { CarouselModule } from "ngx-owl-carousel-o";
import { NgbCarouselModule } from "@ng-bootstrap/ng-bootstrap";

import { ExtrapagesRoutingModule } from "./extrapages-routing.module";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { ComingsoonComponent } from "./comingsoon/comingsoon.component";
import { Page404Component } from "./page404/page404.component";
import { Page500Component } from "./page500/page500.component";
import { UnsubscribeComponent } from "./unsubscribe/unsubscribe.component";

@NgModule({
  declarations: [
    MaintenanceComponent,
    ComingsoonComponent,
    Page404Component,
    Page500Component,
    UnsubscribeComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CarouselModule,
    ExtrapagesRoutingModule,
    NgbCarouselModule,
  ],
  exports: [
    UnsubscribeComponent,
  ],
})
export class ExtrapagesModule {}
